import React from 'react';
// Components
import Navbar from '../../components/nav/Navbar';
import { HelmetItem } from '../../components/utils/HelmetItem';
import LinksPageMainContainer from '../../components/links/LinksPageMainContainer';

// Constants
import {
  CompanyName,
  CompanyTagLine,
  FULL_BUSINESS_URL,
  KeywordsPages,
} from '../../utils/constants/Constants';
import { LINKS_PAGE_URL, HOME_PAGE_URL } from '../../utils/constants/Routes';

// Data
import {
  linksPageAdditionalMeta,
  linksPageStructuredData,
} from '../../utils/data/MetaData';

// Utils
import { buildBreadcrumbLd } from '../../utils/seo/breadcrumbs';
import FAQSchema from '../../utils/seo/FAQSchema';
import { linksPageFaqItems } from '../../utils/data/faqSchemas';

function LinksPage() {
  const breadcrumbLd = buildBreadcrumbLd({
    baseUrl: FULL_BUSINESS_URL,
    items: [
      { label: 'Home', href: HOME_PAGE_URL },
      { label: 'Links', href: LINKS_PAGE_URL },
    ],
  });

  return (
    <>
      {/* Tab Data */}
      <HelmetItem
        PageName='Official Links'
        desc={`Explore all verified links for ${CompanyName}. Access tributes, premium platforms, worship channels, and every authentic way to serve and spoil your Muscle Goddess.`}
        keywords={KeywordsPages}
        additionalMeta={linksPageAdditionalMeta}
        structuredData={[linksPageStructuredData, breadcrumbLd]}
        canonicalPath={LINKS_PAGE_URL}
      />

      {/* Page */}
      <div className='grid overflow-hidden text-colour1 dark:text-colour1 min-h-screen bg-colour2 dark:bg-colour2 font-poppins'>
        <div className='grid min-h-screen'>
          {/* Navigation */}
          <Navbar />

          {/* Header */}
          <header className='pt-24 px-6 lg:container lg:mx-auto lg:px-24'>
            <h1
              aria-label={`Gallery of ${CompanyName}`}
              className='text-center font-titleFont text-6xl lg:text-6xl tracking-widest'
            >
              My Links
            </h1>

            <div className='mx-auto grid justify-center'>
              <h2 className='text-xl xs:text-2xl mt-1 sm:text-3xl md:text-4xl lg:text-4xl lg:py-2 text-center'>
                Find me on your favourite sites
              </h2>
            </div>
          </header>

          {/* Main page content */}
          <LinksPageMainContainer />
        </div>

        {/* FAQ JSON-LD */}
        <FAQSchema items={linksPageFaqItems} />
      </div>
    </>
  );
}

export default LinksPage;
